import React from 'react';
import {
  Box,
  TitleText,
  BenefitTile,
  BenefitType,
  Button,
  ButtonMode,
  ButtonSize,
  Link,
  BenefitTileStatus
} from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';
import { IAvailableBenefits } from '@epi-models/pages/Home';
import config from '@epi-config';

export const ActiveBenefits = ({ benefits }: IAvailableBenefits) => {
  const { gray85, sizeExtraExtraLarge, fontSemiBold } = useTheme();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { enableNewBenefitGroups } = config;

  const navigateToBenefitGroups = () => {
    dispatch(goToPage(routerPaths.benefitGroups));
  };

  return benefits.length ? (
    <Box mb={6}>
      <Box mb={3}>
        <Box display="flex" alignItems="center" gap={2}>
          <TitleText
            fontSize={sizeExtraExtraLarge}
            fontWeight={fontSemiBold}
            noMargin
            color={gray85}
          >
            {t('home.benefits_tile.active_title')}
          </TitleText>
          {enableNewBenefitGroups && (
            <Button
              id="manage-benefits-button"
              mode={ButtonMode.Secondary}
              size={ButtonSize.Medium}
              onClick={navigateToBenefitGroups}
            >
              {t('home.benefits_tile.manage_benefits_button')}
            </Button>
          )}
        </Box>
      </Box>
      <Box
        display="grid"
        gridTemplateColumns="1fr 1fr"
        rowGap={3}
        columnGap={3}
      >
        {benefits.map(elem => (
          <BenefitTile
            key={elem.id}
            title={elem.title}
            status={elem.status}
            benefitType={BenefitType[elem.type.toLowerCase()]}
            description={elem.description}
            buttonContent={
              (elem.benefitType === BenefitType.massage ||
                elem.benefitType === BenefitType.wellbeing) &&
              elem.status === BenefitTileStatus.active && (
                <Link
                  target="_blank"
                  href={t(
                    `components.manage_benefits.new.select_merchants.${elem.benefitType}.url`
                  )}
                >
                  {t('home.benefits_tile.select_merchants_button')}
                </Link>
              )
            }
            labelText={elem.labelText}
          />
        ))}
      </Box>
    </Box>
  ) : null;
};
